var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { FormRepository } from 'packages/form/FormRepository';
import { container } from 'tsyringe';
import { types } from '.';
export var actions = {
    getForms: function (_a, jobId) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        commit(types.SET_LOADING_FORMS, true);
                        _b = commit;
                        _c = [types.SET_FORMS];
                        return [4 /*yield*/, container.resolve(FormRepository).getAllForJob(jobId)];
                    case 1:
                        _b.apply(void 0, _c.concat([_d.sent()]));
                        commit(types.SET_LOADING_FORMS, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    createForm: function (_a, payload) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var form;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(FormRepository).createForm(payload)];
                    case 1:
                        form = _b.sent();
                        commit(types.SET_FORMS, __spreadArray(__spreadArray([], state.forms), [form]));
                        return [2 /*return*/, form];
                }
            });
        });
    },
    updateForm: function (_a, form) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(void 0, void 0, void 0, function () {
            var updatedForm, revalidateResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(FormRepository).update(form.uuid, form)];
                    case 1:
                        updatedForm = _b.sent();
                        commit(types.SET_FORMS, __spreadArray(__spreadArray([], state.forms.filter(function (f) { return f.uuid !== form.uuid; })), [updatedForm]));
                        return [4 /*yield*/, container.resolve(FormRepository).revalidateCachedForm(form.uuid)];
                    case 2:
                        revalidateResponse = _b.sent();
                        if (!revalidateResponse.revalidated) {
                            return [2 /*return*/, Promise.reject(new Error('Failed to revalidate form'))];
                        }
                        return [2 /*return*/, updatedForm];
                }
            });
        });
    },
    deleteForm: function (_a, form) {
        var commit = _a.commit, state = _a.state;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, container.resolve(FormRepository).delete(form.uuid)];
                    case 1:
                        _b.sent();
                        commit(types.SET_FORMS, state.forms.filter(function (f) { return f.uuid !== form.uuid; }));
                        return [2 /*return*/];
                }
            });
        });
    },
    createFormFromTemplate: function (_a, _b) {
        var commit = _a.commit, state = _a.state;
        var template = _b.template, jobId = _b.jobId;
        return __awaiter(void 0, void 0, void 0, function () {
            var form;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, container.resolve(FormRepository).createFromTemplate(template, jobId)];
                    case 1:
                        form = _c.sent();
                        commit(types.SET_FORMS, __spreadArray(__spreadArray([], state.forms), [form]));
                        return [2 /*return*/, form];
                }
            });
        });
    },
};
